export default function (context) {
    if (!context.store.state.account.accountNumber) {
        context.redirect('/Account-picker')
    }
}
